/**
 * The sanctioned "Reason for Non-Completion of 2FA" options for the HIGH and
 * MEDIUM security screens (#287, @dylan219's "Option A with minor additions"
 * ruling, #572). The server-side allow-list (`SANCTIONED_2FA_SKIP_REASONS` in
 * `server/src/api.ts`) must stay in sync with this list.
 */
export const SKIP_2FA_REASONS = [
  'Mobile Number Update',
  '2FA Already Completed',
  '2FA Exemption Approved by TL',
  '2FA PTSB Issue',
  '2FA Network Issue',
  '2FA Customer Device Issue',
] as const;

/**
 * The reason list for the ECL REGISTRATION screen (#699, @dylan219): the two
 * options that relate to post-registration account or session state
 * ("Mobile Number Update", "2FA Already Completed") are not applicable at the
 * point of registration and are removed from the registration dropdown only.
 * The Security screens continue to offer the full six-option list above.
 */
export const REGISTRATION_SKIP_2FA_REASONS = SKIP_2FA_REASONS.filter(
  (r) => r !== 'Mobile Number Update' && r !== '2FA Already Completed',
);

/**
 * The "2FA Customer Device Issue" reason (#789, @dylan219): when the agent
 * selects this reason for non-completion they must first confirm — via a
 * mandatory "Troubleshooting completed" checkbox — that they completed
 * troubleshooting with the customer, before the 2FA-skip can proceed. Exposed
 * as a named constant + predicate so every surface that renders the
 * non-completion reason selector gates on the exact same string. Applies on
 * all such surfaces: the HIGH Security screens and the ECL registration screens.
 */
export const CUSTOMER_DEVICE_REASON = '2FA Customer Device Issue';

export function requiresTroubleshootingConfirmation(reason: string): boolean {
  return reason === CUSTOMER_DEVICE_REASON;
}

/**
 * The reason list offered on HIGH/MEDIUM Security screens. Per @dylan219's
 * #572 ruling the same six options are displayed regardless of whether the
 * customer has a mobile number on file. The `hasMobileOnFile` parameter is
 * retained for call-site compatibility but no longer filters the list.
 */
export function availableSkip2faReasons(
  _hasMobileOnFile: boolean,
): readonly string[] {
  return SKIP_2FA_REASONS;
}
